import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/apps/getxobelaeskola-web/src/app/[locale]/academy/AcademyMain.tsx");
